<template>
    <div class="admin-page">
        <!-- Main content -->
        <div class="main-cnt">
            <div class="content-white">
                <div class="content-header ex-input-heading">
                    <form class="form-group" @submit.prevent="searchOCR">
                        <div class="row">
                            <div class="col-3">
                                <div class="form-input ex-w-50">
                                    <label class="form-input-lb" for="branchId">
                                        {{ $t('branch.general.name') }}
                                    </label>
                                    <div class="form-input-cnt">
                                        <select2
                                            id="branchId"
                                            v-model="search.branchId"
                                            class="" name="branchId"
                                            :options="branchSelectOptions"
                                            :settings="branchSelectSettings"
                                            @change="branchSelectChangeEvent($event)"
                                            @select="branchSelectEvent($event)"></select2>
                                    </div>
                                </div>
                            </div>

                            <div class="col-3">
                                <div class="form-input ex-w-34">
                                    <label class="form-input-lb" for="departmentId">
                                        {{ $t('department.general.name') }}
                                    </label>
                                    <div class="form-input-cnt">
                                        <select2
                                            id="departmentId"
                                            v-model="search.departmentId"
                                            class="" name="departmentId"
                                            :options="departmentSelectOptions"
                                            :settings="departmentSelectSettings"
                                            @change="departmentSelectChangeEvent($event)"
                                            @select="departmentSelectEvent($event)"></select2>
                                    </div>
                                </div>
                            </div>

                            <div class="col-4">
                                <div class="form-input ex-w-84" for="groupId">
                                    <label class="form-input-lb">
                                        {{ $t('group.general.short_name') }}
                                    </label>
                                    <div class="form-input-cnt">
                                        <select2
                                            id="groupId"
                                            v-model="search.groupId"
                                            class="" name="groupId"
                                            :options="groupSelectOptions"
                                            :settings="groupSelectSettings"
                                            @change="groupSelectChangeEvent($event)"
                                            @select="groupSelectEvent($event)"></select2>
                                    </div>
                                </div>
                            </div>

                            <div class="col-2">
                                <button class="btn btn-search-cir" type="submit" :disabled="submitted">
                                    <i class="icon-search-w"></i>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>

                <div class="content-body">
                    <div class="box-content">
                        <div class="row h-100">
                            <div class="col-12 h-100">

                                <div class="block-cnt">

                                    <div class="loading" v-if="(loading == true)" data-vv-scope='s1'></div>

                                    <div class="table-list" v-if="(listsGroup != null) && (loading == false)" data-vv-scope='s2'>
                                        <table class="table">
                                            <tr>
                                                <th>{{ $t('branch.general.full_name') }}</th>
                                                <th>{{ $t('department.general.name') }}</th>
                                                <th>{{ $t('group.general.full_name') }}</th>
                                                <th>{{ $t('login.user_name') }}</th>
                                                <th>{{ $t('ocr.general.date') }}</th>
                                                <th>{{ $t('ocr.general.page') }}</th>
                                                <th>{{ $t('ocr.general.char_count') }}</th>
                                            </tr>

                                            <tr v-for="item in listsGroup" :key="item.id">
                                                <td>{{ item.branch_name }}</td>
                                                <td>{{ item.department_name }}</td>
                                                <td>{{ item.group_name }}</td>
                                                <td>{{ item.user_full_name }}</td>
                                                <td>{{ item.month }}</td>
                                                <td>{{ item.page }}</td>
                                                <td>{{ item.char_count }}</td>
                                            </tr>
                                        </table>
                                    </div>

                                    <div class="clearfix"></div>

                                    <div class="page-block" v-if="lastPage > 1" data-vv-scope='s3'>
                                        <paginate
                                            v-model="page"
                                            :page-count="lastPage"
                                            :page-range="3"
                                            :margin-pages="1"
                                            :click-handler="requestPagination"
                                            :prev-text="$t('pagination.prev')"
                                            :next-text="$t('pagination.next')"
                                            :class="''"
                                            :container-class="'pagination'"
                                            :page-class="'page-item'"
                                            :prev-class="'page-item'"
                                            :next-class="'page-item'"
                                            :page-link-class="'page-link'"
                                            :prev-link-class="'page-link'"
                                            :next-link-class="'page-link'">
                                        </paginate>
                                    </div>

                                    <div class="clearfix"></div>

                                    <div class="no-data" v-if="(listsGroup == null) && (loading == false)" data-vv-scope='s4'>
                                        {{ $t('general.no_data') }}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* global $ */
import _ from 'lodash';
import GroupManagementService from '@/services/admin/group.service';
import OCRManagementService from '@/services/admin/ocr.service';
import StorageService from '@/services/common/storage.service';
import { AuthService } from '@/services/common/auth.service';

import Utils from '@/helpers/utils';
import DateUtils from '@/helpers/dateUtils';

export default {
    components: {
    },
    name: 'ListOCRManagement',
    data () {
        return {
            search: {
                branchId: "",
                departmentId: "",
                groupId: "",
            },

            branchs: [],
            branchSelectOptions: [],
            branchSelectSettings: {
                allowClear: true,
                multiple: false,
                width: '100%',
                theme: 'bootstrap',
                placeholder: this.$t('place_holder.branch'),
                data: this.branchSelectOptions,
            },

            departments: [],
            departmentSelectOptions: [],
            departmentSelectSettings: {
                allowClear: true,
                multiple: false,
                width: '100%',
                theme: 'bootstrap',
                placeholder: this.$t('place_holder.department'),
                data: this.departmentSelectOptions,
            },

            groups: [],
            groupSelectOptions: [],
            groupSelectSettings: {
                allowClear: true,
                multiple: false,
                width: '100%',
                theme: 'bootstrap',
                placeholder: this.$t('place_holder.group'),
                data: this.groupSelectOptions,
            },

            loading: false,
            submitted: false,
            page: 1,
            lastPage: 0,
            lists: null,
        };
    },
    beforeCreate () {
    },
    created () {
        this.fetchData();
        this.getAllDepartments();
        this.getAllBranchs();
        this.getAllGroups();
    },
    beforeMount () {
    },
    mounted () {
    },
    computed: {
        listsGroup: function () {
            this.$forceUpdate();
            if (this.lists && this.lists.length > 0) {
                let _list = [];
                $.each(this.lists, function (key, value) {
                    let item = {
                        branch_name: value.branch_name,
                        department_name: value.department_name,
                        group_name: value.group_name,
                        user_full_name: value.user_full_name,
                        month: DateUtils.formatDateYYYYMM(value.month),
                        page: value.page,
                        char_count: value.char_count,
                    };
                    _list.push(item);
                });
                return _list;
            } else {
                return null;
            }
        },
    },
    watch: {
        '$route' () {
            this.fetchData();
            this.getAllDepartments();
            this.getAllBranchs();
            this.getAllGroups();
        },
    },
    methods: {
        fetchData: function fetchData () {
            this.$forceUpdate();
            this.loading = true;
            this.submitted = true;

            let _page = this.$route.query.page;
            if (Utils.isEmptyStr(_page)) {
                _page = this.page;
            }

            OCRManagementService.listOCR(this.search, _page)
                .then(response => {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    }
                    if (response.status == 200 && response.data.rows.length > 0) {
                        this.lists = response.data.rows;
                        this.lastPage = response.data.last_page;
                        this.page = response.data.current_page;
                    } else {
                        this.lists = null;
                        this.lastPage = 0;
                        this.page = 1;
                    }
                    this.loading = false;
                    this.submitted = false;
                }).catch(error => {
                    this.loading = false;
                    this.submitted = false;
                });

            return false;
        },

        searchOCR: function searchOCR (event) {
            event.preventDefault();
            this.resetData();
            this.fetchData();
            return false;
        },

        resetData: function resetData () {
            this.loading = false;
            this.submitted = false;
            this.page = 1;
            this.lastPage = 0;
            this.lists = null;
        },

        getAllBranchs: function getAllBranchs () {
            GroupManagementService.getAllBranchs()
                .then(response => {
                    if (response.status == 200 && response.data) {
                        let _dataSelect = [];
                        $.each(response.data, function (key, value) {
                            if (!Utils.isEmptyStr(value.id) && Utils.isEmptyStr(value.name)) {
                                return true;
                            }

                            let item = {
                                id: value.id,
                                text: value.name,
                            };
                            _dataSelect.push(item);
                        });

                        this.branchSelectOptions = _dataSelect;
                        this.branchs = _dataSelect;
                    } else {
                        this.branchSelectOptions = [];
                        this.branchs = [];
                    }
                }).catch(error => {
                    this.branchSelectOptions = [];
                    this.branchs = [];
                });
            return false;
        },

        branchSelectChangeEvent (val) {
            if (Utils.isEmptyStr(val)) {
                this.departmentSelectOptions = this.departments;
                this.groupSelectOptions = this.groups;
                return false;
            }

            let _departmentRefer = _.filter(this.departments, function (n) {
                return n.branch_id == val;
            });
            let _groupRefer = _.filter(this.groups, function (n) {
                return n.branch_id == val;
            });
            this.departmentSelectOptions = _departmentRefer;
            this.groupSelectOptions = _groupRefer;
        },

        branchSelectEvent ({id, text}) {
        },

        getAllDepartments: function getAllDepartments () {
            GroupManagementService.getAllDepartments()
                .then(response => {
                    if (response.status == 200 && response.data) {
                        let _dataSelect = [];
                        $.each(response.data, function (key, value) {
                            if (!Utils.isEmptyStr(value.id) && Utils.isEmptyStr(value.name)) {
                                return true;
                            }

                            let item = {
                                id: value.id,
                                text: value.name,
                                branch_id: value.branch_id,
                            };
                            _dataSelect.push(item);
                        });

                        this.departmentSelectOptions = _dataSelect;
                        this.departments = _dataSelect;
                    } else {
                        this.departmentSelectOptions = [];
                        this.departments = [];
                    }
                }).catch(error => {
                    this.departmentSelectOptions = [];
                    this.departments = [];
                });
            return false;
        },

        departmentSelectChangeEvent (val) {
            if (Utils.isEmptyStr(val)) {
                this.groupSelectOptions = this.groups;
                return false;
            }

            let _groupRefer = _.filter(this.groups, function (n) {
                return n.department_id == val;
            });
            this.groupSelectOptions = _groupRefer;
        },

        departmentSelectEvent ({id, text}) {
        },

        getAllGroups: function getAllGroups () {
            GroupManagementService.getAllGroups()
                .then(response => {
                    if (response.status == 200 && response.data) {
                        let _dataSelect = [];
                        $.each(response.data, function (key, value) {
                            if (!Utils.isEmptyStr(value.id) && Utils.isEmptyStr(value.name)) {
                                return true;
                            }

                            let item = {
                                id: value.id,
                                text: value.name,
                                department_id: value.department_id,
                                branch_id: value.branch_id,
                            };
                            _dataSelect.push(item);
                        });

                        this.groupSelectOptions = _dataSelect;
                        this.groups = _dataSelect;
                    } else {
                        this.groupSelectOptions = [];
                        this.groups = [];
                    }
                }).catch(error => {
                    this.groupSelectOptions = [];
                    this.groups = [];
                });
            return false;
        },

        groupSelectChangeEvent (val) {
        },

        groupSelectEvent ({id, text}) {
        },

        requestPagination: function requestPagination (pageNum) {
            /*
                if(pageNum > 1) {
                    this.$router.push({path: '/admin/users', query: {page: pageNum}});
                } else {
                    this.$router.push({path: '/admin/users'});
                }
                */
            // this.page = pageNum;
            this.resetData();
            this.page = pageNum;
            this.fetchData();
            return false;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/admin/OCRManagement/List.vue